/** @file padAtPivot: a tile's pixels on a tile of another size, placed so the pivot pixel stays on its pixel. */
import { blitImage } from '@zilo/pose3d-image-io/image/blitImage';
import { createImage } from '@zilo/pose3d-image-io/image/createImage';
import type { Image } from '@zilo/pose3d-image-io/types/image';

/**
 * A transparent `size` tile with `src` copied at `offset` (whole px: the new pivot pixel minus the old one), so every
 * old pixel keeps its place relative to the pivot; what falls outside the new tile is cropped.
 */
export function padAtPivot(src: Image, size: readonly [number, number], offset: readonly [number, number]): Image {
  const out = createImage(size[0], size[1]);
  blitImage(out, src, Math.round(offset[0]), Math.round(offset[1]));
  return out;
}
